import React, { useEffect, useState } from "react";
import Loading from "../common/loading";
import Markdown from "../common/markdown";

import "./air.css";

const AIRPage = ({ page }) => {
  const [isLoading, setLoading] = useState(true);
  const [displayContent, setContent] = useState("");
  const [gridContent, setLayoutContent] = useState("");
  const [layoutType, setLayoutType] = useState("");

  useEffect(() => {
    // console.log("AIRBasePage mounted");

    // Wait for page content to be available
    if (page.content) {
      setContent(page.content);
      setLoading(false);
    }
    // Set layout if available
    if (page.metadata) {
      let structuredContent = "";
      let metadataJSON = JSON.parse(page.metadata);
      if (metadataJSON.grid) {
        setLayoutType("grid");
        structuredContent = metadataJSON.grid;
      }
      setLayoutContent(structuredContent);
      // setShowPopup(true);
      setLoading(false);
    }
  }, [page]);

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Markdown className="air-content" children={displayContent} />

          {/* 06 grid container */}
          {gridContent &&
            layoutType === "grid" &&
            gridContent.map((item, index) => {
              return (
                <div className="grid-container">
                  <div className="startup-image">
                    <img src={item.imageURL} alt={item.imageAltText} />
                  </div>
                  <span className="startup-header green-bold">
                    {item.title}
                  </span>
                  <Markdown className="startup-content" children={item.body} />
                </div>
              );
            })}
        </>
      )}
    </React.Fragment>
  );
};

export default AIRPage;
